export const PLAN_FEATURES = {
  trial: [
    'taskManagement',
    'progressUpdates',
    'viewTaskDetails'
  ],
  basic: [
    'taskManagement',
    'workerCheckin',
    'workerBreaks',
    'travelTime',
    'progressUpdates',
    'viewTaskDetails',
    'attachments'
  ],
  premium: [
    'taskManagement',
    'workerCheckin',
    'workerBreaks',
    'travelTime',
    'progressUpdates',
    'viewTaskDetails',
    'attachments',
    'commenting',
    'vendorManagement',
    'expenseManagement'
  ],
  ultimate: [
    'taskManagement',
    'workerCheckin',
    'workerBreaks',
    'travelTime', 
    'progressUpdates',
    'viewTaskDetails',
    'attachments',
    'commenting',
    'vendorManagement',
    'expenseManagement',
    'liveTracking',
    'inAppChat',
    'advancedReporting'
  ]
};

// Map features to their required plan level
export const FEATURE_REQUIRED_PLANS = {
  vendorManagement: 'premium',
  expenseManagement: 'premium',
  liveTracking: 'ultimate',
  inAppChat: 'ultimate',
  advancedReporting: 'ultimate',
  attachments: 'basic',
  workerStats: 'basic',
  clientManagement: 'premium',
  commenting: 'premium',
  sendProgress: 'premium'
};

// Also add plan levels as a constant for consistency
export const PLAN_LEVELS = {
  'trial': 0,
  'basic': 1,
  'premium': 2,
  'ultimate': 3
};

// Normalize backend plan values to supported internal keys.
export const normalizePlanName = (planName) => {
  if (!planName || typeof planName !== 'string') return 'trial';

  const normalized = planName.trim().toLowerCase();
  const aliases = {
    trial: 'trial',
    'trial plan': 'trial',
    'free trial': 'trial',
    free: 'trial',
    ultmate: 'ultimate',
    ultimat: 'ultimate',
    'ultimate - monthly': 'ultimate',
    'ultimate - yearly': 'ultimate',
    'premium - monthly': 'premium',
    'premium - yearly': 'premium',
    'basic - monthly': 'basic',
    'basic - yearly': 'basic',
    test: 'trial',
  };

  return aliases[normalized] || normalized;
};
